<div class="container-fluid">
    <div class="row">
        <div class="col-md-2 page-header flex"><a [routerLink]="['/store/service-types']">
            <div pTooltip="{{ 'bikeshop.service_types.import.back' | translate }}" tooltipPosition="left"
                 class="fa fa-chevron-left font-button"></div>
        </a>
            {{ 'bikeshop.cyclist.import_csv' | translate}}</div>
        <div class="col-md-8"></div>
        <div class="col-md-2 flex" style="font-size: 24px;">
            <div pTooltip="{{ 'bikeshop.service_types.import.load_data_from_csv_file' | translate }}"
                 tooltipPosition="left"
                 class="fa hubtiger-import pull-right"
                 style="margin-left:auto;" (click)="fileUpload.click()"></div>
            <a href="/assets/csv-templates/ServiceTypeTemplate.csv" target="_blank" download="ServiceTypeTemplate.csv">
                <div pTooltip="{{ 'bikeshop.service_types.import.download_template_csv' | translate }}"
                     tooltipPosition="left"
                     class="fa hubtiger-export pull-right"></div>
            </a>
        </div>
    </div>
    <div class="content">
        <div class="row margin-top-8" *ngIf="importRecords && importRecords.length>0">
            <div class="col-md-10"></div>
            <div class="col-md-2">
                <button pButton type="button" class="p-button-raised full-width"
                        label="{{ 'bikeshop.service_types.import.import_data' | translate }}"
                        (click)="importData()"></button>
            </div>
        </div>
        <input #fileUpload type="file" accept=".csv" style="display: none;" (change)="importServiceTypes($event)">
        <div class="margin-top-16">
            <p-table #serviceTypesTable [columns]="columns" [value]="importRecords">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'">
                            </p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-serviceType let-columns="columns">
                    <tr [pSelectableRow]="serviceType">
                        <td *ngFor="let col of columns" [ngClass]="{'exists': serviceType['exists']}">
                            <div *ngIf="col.type!=='action'">
                                {{serviceType[col.field]}}
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
